import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { GlobalMenuGroupsRouteNames, GlobalMenuGroupsRoutePathNames } from '../../enums';
import activeBrandsRoute from './views/active-brands';
import archivedBrandsRoute from './views/archived-brands';

const Component = () => import('./GlobalMenuGroupDetails.vue');

export default {
  path: buildChildURL(GlobalMenuGroupsRoutePathNames.ID),
  name: GlobalMenuGroupsRouteNames.GLOBAL_MENU_GROUPS_DETAILS,
  component: Component,
  children: [activeBrandsRoute, archivedBrandsRoute],
  redirect: { name: activeBrandsRoute.name },
} as RouteRecordRaw;
